<template>

	<div class="mt-2 ml-5 accordion">

		<div class="row align-items-center w-100" v-on:mouseover="showHeadingIcons=true" v-on:mouseleave="showHeadingIcons=false">

			<h4 v-on:click="toggleAccordion" class="accordion-title mr-2"
				 :class="{'accordion-outline': !hasSubCategories}">

				{{category.name}}

				<i v-if="!isStatic && !isMaterialCategory"
					class="fa"
					:class="{
					'fa-chevron-down': isOpen,
					'fa-chevron-right': !isOpen
				}"></i>
			</h4>

			<div v-if="showHeadingIcons && !isStatic">

				<button
					v-if="!hasSubCategories"
					v-on:click="copyCategoryPath"
					class="btn btn-outline-secondary btn-sm border-0 mr-2">

					<i class="fa fa-copy fa-lg"></i>
				</button>

				<button v-on:click="editCategoryModal.visible = true" class="btn btn-outline-secondary btn-sm border-0 mr-2">
					<i class="fa fa-pen fa-lg"></i>
				</button>

				<button v-on:click="deleteCategoryModalVisible = true" class="btn btn-outline-danger btn-sm border-0">
					<i class="fa fa-trash fa-lg"></i>
				</button>

			</div>
		</div>

		<div v-show="isOpen">

			<div v-if="hasSubCategories">
				<material-category
					v-for="(subcategory,index) in category.children"
					:key="'mat_cat_' + index"
					:category="subcategory"
					v-on:newCategory="$emit('newCategory', $event)"
					v-on:saveCategory="$emit('saveCategory', $event)"
					v-on:deleteCategory="$emit('deleteCategory', $event)">
				</material-category>
			</div>

			<div v-if="!isMaterialCategory" class="ml-4 my-2">

				<button v-if="!newCategory.visible" v-on:click="newCategory.visible=true" class="btn btn-primary btn-sm">
					<i class="fa fa-plus"></i>
					NEW
				</button>

				<div v-else class="row align-items-center">

					<div class="col-6 ml-2 pr-2">
						<input type="text" class="form-control" placeholder="Category Name" v-model="newCategory.name">
					</div>

					<div class="col-auto pl-1">
						<button v-on:click="saveNewCategory" class="btn btn-primary btn-sm">Save</button>
					</div>

					<div class="col-auto p-0">
						<button v-on:click="closeNewCategoryInput" class="btn btn-outline-secondary btn-sm">Cancel</button>
					</div>
				</div>

			</div>

		</div>

		<modal-dialog
			title="Edit Category"
			:modal-visible="editCategoryModal.visible"
			v-on:closeModal="editCategoryModal.visible = false"
			v-on:confirm="saveCategory">

			<div class="mb-3">
				Old Category Name: <br>
				{{category.name}}
			</div>

			<div>
				New Category Name:
				<input type="text" class="form-control" v-model="editCategoryModal.newName">
			</div>

		</modal-dialog>


		<modal-dialog
			:title="'Delete \''+category.name+'\''"
			:modal-visible="deleteCategoryModalVisible"
			confirm-button-text="Yes, Delete"
			button-class="btn-danger"
			v-on:closeModal="deleteCategoryModalVisible = false"
			v-on:confirm="deleteCategory">

			Are you sure you want to delete this category?

			<div class="font-weight-bold mt-3">

				<span v-if="hasSubCategories">
					({{category.children.length}}) subcategories and
				</span>

				({{category.num_materials}}) materials will also be deleted.
			</div>

		</modal-dialog>

	</div>

</template>

<script type="text/javascript">

import Accordion from "../Accordion";
import ModalDialog from "../ModalDialog";

export default {
	name: "MaterialCategory",
	props: [
		/*
		categories is a list of:
		{
			name: "Category Name"
			children: categories
		}
		 */
		"category",
		"isStatic"
	],
	components: {
		Accordion,
		ModalDialog
	},
	data() {
		return {

			isOpen: this.isStatic,			// Is the accordion open?

			newCategory: {
				visible: false,				// Show "New Category" button
				name: ""							// Name of new category
			},

			showHeadingIcons: false,		// Show edit/delete icons

			editCategoryModal: {
				visible: false,				// Is the edit modal open?
				newName: ""						// Temp storage for new name
			},

			deleteCategoryModalVisible: false,		// Is the delete prompt open?

		}
	},

	computed: {

		hasSubCategories() {
			return ('children' in this.category && this.category.children.length)
		},

		isMaterialCategory() {
			// Category contains only materials -- no subcategories
			return (!this.hasSubCategories && this.category.num_materials > 0)
		}
	},

	methods: {

		copyCategoryPath() {
			let alertText = "'".concat(this.category.path, "' has been copied to clipboard")
			this.copyToClipboard(this.category.path, alertText)
		},

		closeNewCategoryInput() {
			this.newCategory.visible = false
			this.newCategory.name = ""
		},

		saveNewCategory() {
			let vm = this

			// Category names cannot be blank
			if (!this.newCategory.name)
				return

			let payload = {
				name: this.newCategory.name,
				category_id: this.category.id
			}

			vm.$emit("newCategory", payload)

			vm.newCategory.visible = false
			vm.newCategory.name = ""
		},

		saveCategory() {
			let vm = this

			// Must have some kind of name entered
			if (!this.editCategoryModal.newName.length)
				return

			let payload = {
				id: this.category.id,
				name: this.editCategoryModal.newName
			}

			vm.$emit("saveCategory", payload)
			vm.editCategoryModal.visible = false

		},

		deleteCategory() {
			this.$emit("deleteCategory", this.category.id)
			this.deleteCategoryModalVisible = false
		},

		toggleAccordion() {
			if (!this.isStatic) {
				this.isOpen = !this.isOpen
				this.closeNewCategoryInput()
			}
		},


	},

	created() {

	}
}
</script>

<style type="text/css" scoped>

h4 {
	text-decoration: none;
	display: flex;
	justify-content: space-between;
	cursor: pointer;
	align-items: center;
	padding: 8px;
	margin-bottom: 0;

	background-color: var(--background-menus);
}

.accordion {
	margin-bottom: 10px;
}

.accordion-title {
	width:75%;
}

.accordion-outline {
	background-color: var(--background-light);
	border: 2px solid var(--background-menus);
}


@media (max-width: 700px) {

	.accordion-title {
		width: 100%;
	}
}


</style>